var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column cardWrapper mb-16 cardWrapper",style:(_vm.posicaoCard === 'esquerda'
      ? 'margin-left: 64px; justify-self: flex-start'
      : _vm.posicaoCard === 'centro'
      ? 'justify-self: center'
      : _vm.posicaoCard === 'direita'
      ? 'margin-right: 64px; justify-self: flex-end'
      : 'margin-left: 64px; justify-self: flex-start')},[_c('div',{staticClass:"d-flex align-center justify-center pa-2",style:({
      background: _vm.backgroundCard,
      borderColor: _vm.corBorda,
      borderWidth: _vm.strokeWidth,
      borderStyle: 'solid',
    })},[(_vm.hasHours)?_c('span',{staticClass:"timeText",attrs:{"id":"timerContent"}},[_vm._v(_vm._s(_vm.time.split(":").at(0))+":"+_vm._s(_vm.time.split(":").at(1))+":"+_vm._s(_vm.time.split(":").at(2)))]):_c('span',{staticClass:"timeText",attrs:{"id":"timerContent"}},[_vm._v(_vm._s(_vm.time.split(":").at(1))+":"+_vm._s(_vm.time.split(":").at(2)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }